import type { NextPage } from "next";

import Page from "../components/layout/page";
import TermlyEmbed from "../components/termly-embed";

const TermsOfService: NextPage = () => {
  return (
    <Page title="Terms of Use">
      <TermlyEmbed title="Enerflo Terms of Use" id="427a688d-1707-49f7-9afe-ea08d2f0e40e" />
    </Page>
  );
};

export default TermsOfService;
